export class Company {
    id: number;
    company_name: string;
    tax_id: string;
    // Backend-derived classification from the TIN, e.g. 'INDIVIDUAL' | 'ENTITY'.
    taxpayerType?: string;
    first_name: string;
    last_name: string;
    properties: any;
  }
  